import HeroSection from "./components/Hero";
import HistorySection from "./components/History";
import InnovationGapSection from "./components/InnovationGap";
import VisionSection from './components/VisionSection';

export default function TheNeedPage() {
  return (
    <div className="flex flex-col">
      <HeroSection />
      <HistorySection />
      <InnovationGapSection />
      <VisionSection />
    </div>
  );
}
